/**
 * @generated SignedSource<<1490bb805b5c70a50d6c8525ce09bf93>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespSharedBuyerAssurance_user$data = {
  readonly isVerifiedTrade: boolean | null;
  readonly " $fragmentType": "PdpRespSharedBuyerAssurance_user";
};
export type PdpRespSharedBuyerAssurance_user$key = {
  readonly " $data"?: PdpRespSharedBuyerAssurance_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSharedBuyerAssurance_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSharedBuyerAssurance_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isVerifiedTrade",
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "28b9bcb13f4e733fedeb0fb6eff2a20f";

export default node;
